import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import { Modal, Button, Form } from "react-bootstrap";

import Select from "react-select";

import {
  CHECK_ENGINE_VIN_REQUEST,
  checkEngineVin,
} from "../../../../redux/RegistrationChangesInformationRHFReducer/actionsRegistrationChangesInformationRHF";

import { customStyles } from "./engineModalStyle";
import styles from "./engineModal.module.css";

const EngineModal = ({
  engineTypes,
  onSubmit,
  isOpen,
  onClose,
  initialValues = {},
  engpwrmax,
}) => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    reset,
    control,
    formState: { errors },
  } = useForm();

  const checkEngineVinLoading = useSelector(
    (state) =>
      state.registrationChangesInformationRHFReducer.checkEngineVinLoading,
  );
  const checkEngineVinError = useSelector(
    (state) =>
      state.registrationChangesInformationRHFReducer.checkEngineVinError,
  );

  const [selectedEngineType, setSelectedEngineType] = useState(null);

  const handleClose = () => {
    dispatch({ type: CHECK_ENGINE_VIN_REQUEST });
    onClose();
    reset();
  };

  const onFormSubmit = async (data) => {
    dispatch(checkEngineVin({ engineVin: data.engvin, engname: data.engname }));
  };

  useEffect(() => {
    if (!checkEngineVinLoading && !checkEngineVinError) {
      handleFinalSubmit();
    }
  }, [checkEngineVinLoading, checkEngineVinError]);

  const handleFinalSubmit = () => {
    const selectedType = engineTypes.find(
      (type) => type.value === Number(getValues("engtype")),
    );

    const formData = {
      ...getValues(),
      engtype: selectedType ? selectedType.value : getValues("engtype"),
      engtypeName: selectedType ? selectedType.label : getValues("engtype"),
    };

    onSubmit(formData);
    handleClose();
  };

  useEffect(() => {
    if (isOpen && initialValues) {
      Object.keys(initialValues).forEach((key) => {
        setValue(key, initialValues[key]);
      });

      const initialType = engineTypes.find(
        (type) => type.value === initialValues.engtype,
      );
      setSelectedEngineType(initialType || null);
    } else {
      reset();
      setSelectedEngineType(null);
    }
  }, [isOpen, initialValues, engineTypes]);

  const handleSelectChange = (selectedOption) => {
    setValue("engtype", selectedOption ? selectedOption.value : "");
    setSelectedEngineType(selectedOption);
  };

  const validateBoatYear = (value) => {
    if (Number(value)) {
      if (value > new Date().getFullYear()) {
        return "Год не может быть позднее текущего";
      } else {
        return true;
      }
    }
  };

  const validateEnginePower = (value) => {
    if (!value) {
      return "Мощность обязательна";
    } else if (engpwrmax && Number(value) > engpwrmax) {
      return `Мощность не может быть больше ${engpwrmax}`;
    } else if (!engpwrmax) {
      return "Предельная мощность двигателей не заполнена";
    } else {
      return true;
    }
  };

  return (
    <Modal show={isOpen} onHide={handleClose} centered>
      <Modal.Header className={styles["form-header"]} closeButton>
        <Modal.Title className={styles["form-title"]}>
          Сведения о двигателе маломерного судна
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>
        <Form onSubmit={handleSubmit(onFormSubmit)}>
          <Form.Group className={styles["form-data"]} controlId="engname">
            <Form.Label>
              Название <span className={styles["red-dot"]}>*</span>
            </Form.Label>
            <Form.Control
              className={styles["form-input"]}
              type="text"
              placeholder="Введите название"
              {...register("engname", { required: "Название обязательно" })}
            />
            {errors.engname && (
              <p className={styles["error-message"]}>
                {errors.engname.message}
              </p>
            )}
          </Form.Group>

          <Form.Group className={styles["form-data"]} controlId="engvin">
            <Form.Label>
              Заводской (идентификационный) номер
              <span className={styles["red-dot"]}>*</span>
            </Form.Label>
            <Form.Control
              className={styles["form-input"]}
              type="text"
              placeholder="Введите заводской номер"
              {...register("engvin", {
                required: "Заводской номер обязателен",
              })}
            />
            {errors.engvin && (
              <p className={styles["error-message"]}>{errors.engvin.message}</p>
            )}
          </Form.Group>

          <Form.Group className={styles["form-data"]} controlId="engtype">
            <Form.Label>
              Тип двигателя <span className={styles["red-dot"]}>*</span>
            </Form.Label>
            <Controller
              name="engtype"
              control={control}
              rules={{ required: "Тип двигателя обязателен" }}
              render={({ field }) => (
                <Select
                  {...field}
                  styles={customStyles}
                  options={engineTypes.map((type) => ({
                    value: type.value,
                    label: type.label,
                  }))}
                  value={selectedEngineType}
                  onChange={(selectedOption) => {
                    field.onChange(selectedOption);
                    handleSelectChange(selectedOption);
                  }}
                  placeholder="Выберите тип двигателя"
                />
              )}
            />
            {errors.engtype && (
              <p className={styles["error-message"]}>
                {errors.engtype.message}
              </p>
            )}
          </Form.Group>

          <Form.Group className={styles["form-data"]} controlId="engpwr">
            <Form.Label>
              Мощность, л.с. <span className={styles["red-dot"]}>*</span>
            </Form.Label>
            <Form.Control
              className={styles["form-input"]}
              type="text"
              placeholder="Введите мощность"
              {...register("engpwr", {
                required: "Мощность обязательна",
                validate: validateEnginePower,
                onChange: (e) => {
                  e.target.value = e.target.value.replace(",", ".");
                },
              })}
            />
            {errors.engpwr && (
              <p className={styles["error-message"]}>{errors.engpwr.message}</p>
            )}
          </Form.Group>

          <Form.Group className={styles["form-data"]} controlId="engProdYear">
            <Form.Label>
              Год выпуска <span className={styles["red-dot"]}>*</span>
            </Form.Label>
            <Form.Control
              className={styles["form-input"]}
              type="text"
              placeholder="Введите год выпуска"
              {...register("engProdYear", {
                required: "Год выпуска обязателен",
                validate: validateBoatYear,
              })}
            />
            {errors.engProdYear && (
              <p className={styles["error-message"]}>
                {errors.engProdYear.message}
              </p>
            )}
          </Form.Group>

          {checkEngineVinError && (
            <p className={styles["error-message"]}>{checkEngineVinError}</p>
          )}

          <div className={styles["form-footer"]}>
            <Button
              className={styles["save-btn"]}
              variant="primary"
              type="submit"
            >
              Сохранить
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EngineModal;
